import { SUPPORTED_UPSELL_KINDS } from './constants'
import { UnifiedOnboardingStoreState, UpsellOffer } from './types'

export const reducers = {
  setUpsellOffers: (
    state: UnifiedOnboardingStoreState,
    { payload }: { payload: UpsellOffer[] },
  ) => ({
    ...state,
    upsellOffers: payload.filter((offer) => SUPPORTED_UPSELL_KINDS.includes(offer.kind)),
  }),

  skipUpsellOffer: (state: UnifiedOnboardingStoreState, { payload }: { payload: number }) => ({
    ...state,
    upsellOffers: state.upsellOffers.map((offer, index) =>
      index === payload ? { ...offer, skipped: true } : offer,
    ),
  }),

  completeUpsellOffer: (state: UnifiedOnboardingStoreState, { payload }: { payload: number }) => ({
    ...state,
    upsellOffers: state.upsellOffers.map((offer, index) =>
      index === payload ? { ...offer, completed: true } : offer,
    ),
  }),
}
